import { render, staticRenderFns } from "./seeDetails.vue?vue&type=template&id=25b9f010&scoped=true"
import script from "./seeDetails.vue?vue&type=script&lang=js"
export * from "./seeDetails.vue?vue&type=script&lang=js"
import style0 from "./seeDetails.vue?vue&type=style&index=0&id=25b9f010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9f010",
  null
  
)

export default component.exports